import React from 'react';
import { FormattedMessage } from 'react-intl';
import styled from 'styled-components';

export const footerHeight = '75px';

const Wrapper = styled.footer`
  height: ${footerHeight};
  width: 100%;
  padding: 0 3.5rem;
  display: flex;
  justify-content: flex-end;
  align-items: center;
  border-top: 1px solid #e7e7e7;
`;

export const Footer = () => {
  return (
    <Wrapper>
      <FormattedMessage id="version" /> {process.env.VERSION}
    </Wrapper>
  );
};
